// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro--intro--1ikoV","intro__col":"Intro--intro__col--1DEvw","intro__text":"Intro--intro__text--3TVV0"};